// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_QBk","cls2":"dossier-cls2_zVS dossier-cls1_QBk"};